export class MachineIdList {
  machineIds: number [] = [];
}